// extracted by mini-css-extract-plugin
module.exports = {"normal":"buttons_normal__3eLlr","white":"buttons_white__2gul_","muted":"buttons_muted__3pkrL","nav":"buttons_nav__oimUJ","link":"buttons_link__1sFka","text":"buttons_text__1WZ-k"};